import { render, staticRenderFns } from "./GoalsCard.vue?vue&type=template&id=0f973423&scoped=true&"
import script from "./GoalsCard.vue?vue&type=script&lang=js&"
export * from "./GoalsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoalsCard.vue?vue&type=style&index=0&id=0f973423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f973423",
  null
  
)

export default component.exports